export const GET_ALL_MARKETS = "GET_ALL_MARKETS"
export const GET_ALL_MARKETS_RESPONSE_SUCCESS =
  "GET_ALL_MARKETS_RESPONSE_SUCCESS"

export const CREATE_MARKET_NAME = "CREATE_MARKET_NAME"
export const CREATE_ROLE_RESPONSE_SUCCESS = "CREATE_ROLE_RESPONSE_SUCCESS"

export const DELETE_MARKET = "DELETE_MARKET"
export const DELETE_MARKET_RESPONSE_SUCCESS =
  "DELETE_MARKET_RESPONSE_SUCCESS"
export const DELETE_MARKET_RESPONSE_ERROR =
  "DELETE_MARKET_RESPONSE_ERROR"

export const EDIT_MARKET = "EDIT_MARKET"
export const EDIT_MARKET_RESPONSE_SUCCESS =
  "EDIT_MARKET_RESPONSE_SUCCESS"
export const EDIT_MARKET_RESPONSE_ERROR = "EDIT_MARKET_RESPONSE_SUCCESS"
